import ArrowBottomRight from './ArrowBottomRight'

export default ArrowBottomRight
// eslint-disable-next-line import/export
export * from './ArrowBottomRight'
